import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPhone,
  faEnvelope,
  faMapMarkerAlt,
} from "@fortawesome/free-solid-svg-icons";
import { faFacebookF, faInstagram } from "@fortawesome/free-brands-svg-icons";
import logo from "../../assets/logoo.png";
import "./FooterStyle.css";

const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer-section">
      <div className="footer-content">
        <div className="footer-grid">
          <div className="footer-logo">
            <img src={logo} alt="Logo" className="logo-img" />
            <p>{t("footer.ali_eldeeb_praise")}</p>
          </div>

          <div className="footer-links">
            <h3>{t("footer.links_title")}</h3>
            <ul>
              <li>
                <a href="#home">{t("nav.home")}</a>
              </li>
              <li>
                <a href="#about">{t("nav.about")}</a>
              </li>
              <li>
                <a href="#services">{t("nav.services")}</a>
              </li>
              <li>
                <a href="#projects">{t("nav.projects")}</a>
              </li>
              <li>
                <a href="#contact">{t("nav.contact")}</a>
              </li>
            </ul>
          </div>

          <div className="footer-contact">
            <h3>{t("footer.contact_title")}</h3>
            <ul className="contact-list">
              <li>
                <FontAwesomeIcon
                  icon={faMapMarkerAlt}
                  className="contact-icon"
                />
                {t("footer.address")}
              </li>
              <li>
                <FontAwesomeIcon icon={faPhone} className="contact-icon" />
                <a href={`tel:${t("footer.phone")}`} className="phone-link">
                  {t("footer.phone")}
                </a>
              </li>
              <li>
                <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
                <a href={`mailto:${t("footer.email")}`} className="email-link">
                  {t("footer.email")}
                </a>
              </li>
            </ul>
            <div className="footer-social-icons">
              <a
                href="https://www.facebook.com/share/1Ecmj1AWs9/?mibextid=wwXIfr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faFacebookF} />
              </a>
              <a
                href="https://www.instagram.com/ali.mnshay123123?igsh=dzc1MTc3bHkxZTJp&utm_source=qr"
                target="_blank"
                rel="noopener noreferrer"
              >
                <FontAwesomeIcon icon={faInstagram} />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="footer-bottom">
        <p>
          {t("footer.developed_by")}
          <a
            href="https://osamaabushama1.github.io/Portfolio/"
            target="_blank"
            rel="noopener noreferrer"
            className="developer-link"
          >
            Osama
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
